<template>
  <div class="container-fluid">
    <Card>
      <template v-slot:header>
        <h3>بـروز رســانی گروه بندی هــا</h3>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-lg-3 col-12">
            <small>انتخاب دسته بندی گروه</small>
            <SearchableCombo :edit="false" :code="null" :grp="null" @ResultCombo="returnCOMBO" :rownumintable="3" :action="'BasicInformation/GetGrpCombo'" :method="'GET'" :idinput="'GrpCombo'" :keyItem="'GrpCombo'"> </SearchableCombo>
          </div>
          <div class="col-lg-6 col-12"></div>
          <div class="col-lg-3 col-12">
            <button v-if="ComboParentList.length > 0" @click="SaveChanges()" class="btn mt-4 btn-success w-100">ثبت تغییرات</button>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <a v-if="ComboParentList.length > 0" @click="Addparent()">
              <div data-title="اضافه کردن   دسته بندی">
                <i class="fas fa-plus text-info"></i>
              </div>
            </a>
          </div>
          <div v-for="(item, index) in ComboParentList" :key="index" class="m-2 col-10 ml-5 mr-5">
            <div class="Scard row">
              <div class="w-100 position-relative">
                <span>
                  <input type="text" class="form-control no-border" v-model="ComboParentList[index].name" />
                </span>
                <span class="Top-right">
                  <a @click="AddChild(item)" data-title="اضافه کردن زیرمجموعه به دسته بندی"><i class="fas fa-plus text-success m-1"></i></a>
                  <a @click="RemoveGrp(item)" data-title="حذف دسته بندی"><i class="fas fa-times text-danger m-1"></i></a>
                </span>
              </div>
              <div class="col-12 row">
                <div v-for="(child, cindex) in ComboChildList.filter((x) => x.parentId == item.id)[0].children" :key="cindex" class="col-5 m-2">
                  <input type="text" class="form-control no-border" v-model="child.name" />
                </div>
              </div>
              <div class="row w-100" v-if="RoleAutomation">
                <div class="col-12">
                  <div class="text-center mr-5">
                    <div class="custom-control custom-switch">
                      <small id="LbltblComboGrpId50" class="ml-2 text-danger"> درصورتی که نقش تعریف شده در بالاترین سطح قرار میگیرند ، باکس مقابل را فعال نمایید </small>
                      <input type="checkbox" class="custom-control-input required InputText" :id="'Done'+index" v-model="ComboParentList[index].wwwHasBeenChanged" />
                      <label class="custom-control-label" :for="'Done'+index"> </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </template>
    </Card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'

export default {
  data() {
    return {
      ComboParentList: [],
      ComboChildList: [],
      dataReturnCombo: {},
      RoleAutomation:false
    }
  },
  methods: {
    returnCOMBO(data) {
      console.warn(data)
      this.dataReturnCombo = data
      if (data.id != null) {
        if (data.id ==322) {
          this.RoleAutomation=true
        }
        else{
          this.RoleAutomation=false
        }
        var DataAxiosGetCombo = { Method: 'Post', Action: 'BasicInformation/GetChildsCombo', ArryfildValue: { Id: data.id } }
        this.$PostData(DataAxiosGetCombo).then((result) => {
          this.ComboParentList = result.parents
          this.ComboChildList = result.children
        })
      }
    },
    AddChild(data) {
      var ListToAdd = this.ComboChildList.filter((x) => x.parentId == data.id)[0].children
      // console.log({ ListToAdd })
      if (ListToAdd.length > 0) {
        var temp = JSON.parse(JSON.stringify(ListToAdd[0]))
        temp.name = ''
        temp.id = 98989
        this.ComboChildList.filter((x) => x.parentId == data.id)[0].children.push(temp)
      } else {
        this.$mySweetDefaultTost('هشدار', 'تعریف زیرمجوعه برا این دسته بندی امکان پذیر نیست', 'warning', 2000)
      }
    },
    Addparent() {
      var temp = JSON.parse(JSON.stringify(this.ComboParentList[0]))
      temp.name = ''
      temp.id = 98989
      temp.wwwHasBeenChanged = false
      this.ComboParentList.push(temp)
      this.ComboChildList.push({ parentId: temp.id, children: [] })
    },
    SaveChanges() {
      var NodesToUpdate = []
      this.ComboChildList.forEach((Element) => {
        Element.children.forEach((child) => {
          NodesToUpdate.push(child)
        })
      })
      this.ComboParentList.forEach((Element) => {
        NodesToUpdate.push(Element)
      })
      var data = { NodesToUpdate }
      var DataAxiosSave = { Action: 'BasicInformation/saveChange', Method: 'POST', ArryfildValue: { inputList: NodesToUpdate, tblusergrp: this.$session.get('UserInfo').tblUserGrpId } }
      this.$PostData(DataAxiosSave)
        .then((result) => {
          if (result.status == 'success') {
            this.$mySweetDefaultTost('عملیات موفق', 'تغییرات با موفقیت اعمال شد', 'success', 2000)
          } else {
            this.$mySweetDefaultTost('عملیات ناموفق', 'مشکلی بودجود آمده است', 'warning', 2000)
          }
        })
        .catch((error) => {
          this.$mySweetDefaultTost('عملیات ناموفق', 'مشکلی بودجود آمده است' + error, 'warning', 2000)
        })
    },
    RemoveGrp(data) {
      var DataAxiosGetCombo = { Method: 'Post', Action: 'BasicInformation/RemoveGrp', ArryfildValue: { Id: data.id } }

      this.$PostData(DataAxiosGetCombo).then((result) => {
        if (result.status == 'success') {
          this.$toasted.success('دسته بندی با موفقیت حذف شد.', {
            action: {
              text: 'بستن',
              onClick: (e, toastObject) => {
                toastObject.goAway(0)
              },
            },
          })
        }
        this.returnCOMBO(this.dataReturnCombo)
      })
    },
  },
  components: { Card, SearchableCombo },
}
</script>
<style scoped>
.Scard {
  border-radius: 15px;
  border: solid 1px var(--logo-color) !important;
  overflow: hidden;
  width: 100% !important;
  height: 100% !important;
}
.Top-right {
  position: absolute;
  top: 20%;
  left: 3%;
}
</style>
